/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Intransit from './Intransit';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import Link from '../../../../../components/ZUILib/Link';
import pdfUtil from '../../../../../utils/PDFUtil';
import Image from '../../../../../components/ZUILib/Image';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import {
  constDownload,
  constPrint,
  constSendMail,
  eventStatus,
  eventType,
  eventCategory,
} from '../../../../../utils/clientConstant';
import ValeSystemModal from './valeSystemModal';
import TemporaryClosingModal from './temporaryClosingModal';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import { sendMail } from '../../actions';
import Tagging from '../../../../../components/Tagging/Tagging';

import commonUtil from '../../../../../utils/commonUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'accountstatus';
export default class AccountStatus extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.eventOwnerId = this.props.eventInfo && this.props.eventInfo.ownerId;
    this._StartTime = '';
    this._EndTime = '';
    this.AllowedStartTime = '';
    this.AllowedEndTime = '';
    this.isValeSystemDown = false;
    this.state = {
      emailSendStatus: null,
      accountStatementError: null,
    };
  }

  gtmEarlyRetirement = () => {};

  onCerrarMesaButtonClick = () => {
    this.temporaryClosingModal.handleShow();
  };

  onTemporaryClosingModalAcceptor = () => {
    // redirect to cierre
    this.temporaryClosingModal.handleHide();
    browserHistory.push({
      pathname: commonUtil.getRouteByParameter(
        applicationRoutes.closureTransference,
        {
          eventID: this.eventId,
        },
      ),
      state: {
        eventOwnerId: this.eventOwnerId,
        openEvent:
          this.props.eventInfo.eventCategory === eventCategory.OPENEVENT,
      },
    });
  };

  onPartialTransferenceButtonClick = () => {
    if (this.isValeSystemDown) {
      this.valeSystemModal.handleShow();
    } else {
      // redirect to Retiros Anticipados
      this.gtmEarlyRetirement();
      browserHistory.push({
        pathname: commonUtil.getRouteByParameter(
          applicationRoutes.partialTransference,
          { eventID: this.eventId },
        ),
        state: { eventOwnerId: this.eventOwnerId },
      });
    }
  };

  UNSAFE_componentWillMount() {
    const accountStatus = this.props.accountStatus;
    this.currentTime = accountStatus.currTime;
    this._StartTime = commonUtil.formatDate(
      accountStatus.eventAccountStatementInfo.transferenceAllowedStartTime,
      'hour12',
    );
    this._EndTime = commonUtil.formatDate(
      accountStatus.eventAccountStatementInfo.transferenceAllowedEndTime,
      'hour12',
    );
    // ----- INSPECT: System Available -----
    this.isValeSystemDown = !accountStatus.accountSystemAvailable;
  }

  openTransitModal = () => {
    this.transitModal.handleShow();
  };
  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  };
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  };
  getStatementDetailsForSendMail = () => {
    this.printDownloadMail(constSendMail);
  };
  accountStatementSendMail = (fileName, data) => {
    const emailId =
      !commonUtil.isObjectEmpty(this.props.user) &&
      this.props.user.result &&
      this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({
          emailSendStatus: {
            isSent: true,
            resMsg: commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.emailsent.message',
            ),
          },
        });
      } else {
        this.setState({
          emailSendStatus: {
            isSent: false,
            resMsg: commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.emailfailed.message',
            ),
          },
        });
      }
    });
  };

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }

  printDownloadMail = (type) => {
    if (type === constSendMail) {
      const mailContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
          download
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDomForMail(
        mailContent,
        'accountStatement',
        this.accountStatementSendMail,
      );
    } else if (type === constDownload) {
      const downloadableContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
          download
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDom(downloadableContent, 'accountstatus_' + this.eventId);
    } else if (type === constPrint) {
      const printContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  };

  render() {
    const lables = this.props.lables;
    const itemInfo =
      this.props.accountStatus.eventAccountStatementInfo.itemsInfo;
    const amountInfo =
      this.props.accountStatus.eventAccountStatementInfo.amountInfo;
    const accountData = this.props && this.props.accountStatus && this.props.accountStatus.eventAccountStatementInfo;
    // const isEmployeeEvent = this.props.eventInfo.isEmployeeEvent;
    let eventIconImageURL =
      commonUtil.getAssetURL() + '/images/gifts/gift_bodas.svg';
    const eventTypeForIcon =
      this.props.eventInfo && this.props.eventInfo.eventType
        ? this.props.eventInfo.eventType
        : undefined;
    const isBonusContainerVisible = commonUtil.isBonusAvailable(
      this.props.eventInfo,
    );

    switch (eventTypeForIcon) {
      case eventType.Boda:
      case eventType.Aniversario:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_bodas.svg';
        break;
      case eventType.Bebe:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_bebes.svg';
        break;
      case eventType.XV_Anos:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_quince.svg';
        break;
      case eventType.Bar_Mitzvah:
      case eventType.Baptism:
      case eventType.Bat_Mitzvah:
      case eventType.First_Communion:
      case eventType.Confirmacion:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_cumple.svg';
        break;
      case eventType.Other_Religious_Ceremonies:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_ceremonias.svg';
        break;
      case eventType.Fiesta_Reunion:
      case eventType.Fiesta_Infantil:
      case eventType.Despedida:
      case eventType.Open_House:
      case eventType.Cumpleanos:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_cumpleanos.svg';
        break;
      case eventType.Others:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_todotipo.svg';
        break;
      case eventType.Mascotas:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_todotipo.svg';
        break;
      default:
        break;
    }
    const eventIconImageAttr = {
      id: 'img1',
      alt: 'Liverpool',
      src: eventIconImageURL,
      altImg: commonUtil.getAssetURL() + '/images/gifts/gift_bebes.svg',
      className: 'eventMessageImage',
    };

    const eventProfileImageLink = {
      id: 'link',
      alt: 'Liverpool',
      src: this.props.eventInfo && this.props.eventInfo.eventProfileImage,
      altImg: commonUtil.getAssetURL() + '/images/avatar.svg',
    };
    const datosLink = {
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'DatosDeMiEvento',
        eventID: this.props.eventId,
      }),
    };
    const cerrarMesaButton = {
      type: 'button',
      value: 'Cerrar Mesa',
      id: 'CerrarMesa',
      autoFocus: false,
      cssStyle: {
        borderRadius: '4px',
      },
      disabled:
        accountData.enableEventClosure.toString() === 'true' ? '' : 'disabled',
      style:
        accountData.enableEventClosure.toString() === 'true'
          ? 'btnPrimary size-Full'
          : 'btnPrimary primaryDisabled size-Full',
      onClickHandler: this.onCerrarMesaButtonClick,
    };

    const linkDatosDeEvento = {
      displayName: 'Datos de mi evento',
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'DatosDeMiEvento',
        eventID: this.eventId,
      }), // TODO: Routing - this route needs to be reviewd as this won't load the event management page and it requires the eventId [NS]
    };
    const DownloadIcon = {
      route: '',
    };
    const PhysicalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.physicalGifts, {
        eventID: this.eventId,
      }),
    };

    const PersonalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.personalPurchases,
        { eventID: this.eventId },
      ),
    };
    const ElectronicJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.electronicsGift, {
        eventID: this.eventId,
      }),
    };
    const AccountPartialTransferJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.accountsPartialTransfer,
        { eventID: this.eventId },
      ),
    };
    const BonusDetails = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.bonusDetails, {
        eventID: this.eventId,
      }),
    };

    const partialTransferenceButton = {
      id: 'partialTransferance',
      type: 'button',
      value: 'Retiro anticipado',
      disabled:
        accountData.enablePartialTransfer.toString() === 'true'
          ? ''
          : 'disabled',
      autoFocus: false,
      style:
        accountData.enablePartialTransfer.toString() === 'true'
          ? 'specialLink size-Full'
          : 'specialLink specialDisabled size-Full',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.onPartialTransferenceButtonClick,
      onClick: this.gtmEarlyRetirement,
    };

    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ emailSendStatus: null });
      },
    };
    const accountStatementErrorLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ accountStatementError: null });
      },
    };

    const inTransitHeaderData = (
      <p>
        {commonUtil.getLabel(
          lables['In transit – Pop up'],
          'accountStatement.intransit.message',
        )}
      </p>
    );

    const webCloseModal = {
      backgroundColor: '#F5F5F5',
      padding: '4%',
      margin: '-6%',
      borderRadius: '12px 12px 0 0',
    };

    const webCloseBtn = {
      marginTop: '-2%',
      backgroundColor: 'transparent',
    };

    const webCloseSpan = {
      color: '#666666',
      opacity: 1,
      fontSize: '1.2em',
    };

    /* eslint-disable */
    return (
      <React.Fragment>
        <Tagging ref={(tagging) => (this.tagging = tagging)} />
        <div className='adminContainer'>
          <div className='adminSummary'>
            <div className='adminInfo'>
              <div className='adminImage'>
                <Image imageAttr={eventProfileImageLink} />
              </div>
              <div className='adminData'>
                <h2>{this.props.eventInfo.eventName}</h2>
                <span className='eventDate'>
                  {commonUtil.getLabel(
                    lables.eventAccountStatement,
                    'accountStatement.eventDate.Label'
                  )}
                  : {this.props.eventInfo.eventDate}
                </span>
                <span className='eventID'>
                  {commonUtil.getLabel(
                    lables.eventAccountStatement,
                    'accountStatement.eventId.Label'
                  )}
                  : {this.props.eventInfo.eventId}
                </span>
                <Link rrLink={datosLink}>
                  <label className='icon-datos_de_mi_evento' />
                </Link>
                <Link rrLink={linkDatosDeEvento}>
                  <span>
                    {lables
                      ? commonUtil.getLabel(
                          lables.EventAdminPage,
                          'adminpage.summary.eventdatapage.hyperlink.message'
                        )
                      : ''}
                  </span>
                </Link>
              </div>
            </div>
            {this.props && this.props.eventInfo && this.props.eventInfo.eventStatus === eventStatus.CLOSED ? (
              <div className='eventBlock'>
                <div className='eventButtons' />
                <p>
                  <strong>
                    ¡
                    {commonUtil.getLabel(
                      lables['event closure success page'],
                      'eventClosure.success.message'
                    )}
                    !
                  </strong>
                  <br />
                  {commonUtil.getLabel(
                    lables['event statement page'],
                    'eventClosure.closed.message'
                  )}
                  .
                </p>
              </div>
            ) : (
              <div className='eventBlock'>
                {accountData.eventMessage &&
                accountData.eventMessage.indexOf('Muchas') > -1 ? (
                  <div className='daysLeft congratulations'>
                    <div>
                      {/* <i className='icon-bandera_boda' /> */}
                      <Image imageAttr={eventIconImageAttr} />
                    </div>
                    <p>{accountData.eventMessage}</p>
                  </div>
                ) : (
                  <div className='daysLeft congratulations'>
                    <p>{accountData.eventMessage}</p>{' '}
                  </div>
                )}
                <div className='eventButtons' />
                <InputButton buttonAttr={cerrarMesaButton} />
                {accountData.employeeClosureMessage ? (
                  accountData.eventMessage.indexOf('No cuentas') === -1 ? (
                    <p style={{ paddingTop: '5%' }}>
                      No cuentas con tu tarjeta Liverpool registrada, para
                      cerrar tu mesa de regalos visita tienda.
                    </p>
                  ) : (
                    <p>{accountData.employeeClosureMessage}</p>
                  )
                ) : (
                  <React.Fragment>
                    {accountData.eventMessage &&
                    accountData.eventMessage.indexOf('Muchas') > -1 ? (
                      ''
                    ) : (
                      <div>
                        {commonUtil.getLabel(
                          lables.eventAccountStatement,
                          'accountStatement.closure.message'
                        )}
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        </div>
        <div className='adminAccountStateContainer'>
          <div className='adminContainer'>
            {this.state.emailSendStatus ? (
              <React.Fragment>
                {this.state.emailSendStatus.isSent ? (
                  <div className='alertSuccess'>
                    {' '}
                    <i className='icon-check' />
                    <p>{this.state.emailSendStatus.resMsg}</p>
                    <Link linkJSON={emailSendLink} />
                  </div>
                ) : (
                  <div className='alertError'>
                    {' '}
                    <i className='icon-tache2' />
                    <p>{this.state.emailSendStatus.resMsg}</p>
                    <Link linkJSON={emailSendLink} />
                  </div>
                )}
              </React.Fragment>
            ) : null}

            {this.state.accountStatementError ? (
              <div className='alertError'>
                {' '}
                <i className='icon-tache2' />
                <p>{this.state.accountStatementError}</p>
                <Link linkJSON={accountStatementErrorLink} />
              </div>
            ) : null}

            <div className='row bb-1'>
              <div className='col-md-8'>
                <h3>ESTADO DE CUENTA</h3>
              </div>
              <div className='col-md-4'>
                <div className='toolsLink text-right'>
                  <Link rrLink={DownloadIcon}>
                    <i
                      className='icon-correo'
                      onClick={this.getStatementDetailsForSendMail}
                      aria-hidden='true'
                    />
                  </Link>
                  <Link rrLink={DownloadIcon}>
                    <i
                      className='icon-descarga'
                      onClick={this.getStatementDetailsForDownload}
                      aria-hidden='true'
                    />
                  </Link>
                  <Link rrLink={DownloadIcon}>
                    <i
                      className='icon-imprimir'
                      onClick={this.getStatementDetailsForPrint}
                      aria-hidden='true'
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className='additionalInfo'>
              <p>
                {commonUtil.getLabel(
                  lables.eventAccountStatement,
                  'accountStatement.statement.message'
                )}
              </p>
            </div>
          </div>
          <div className='adminContainer'>
            <div className='row'>
              <div className='col-md-9'>
                <div className='contentInfoStatement'>
                  <table className='accountStatement'>
                    <thead>
                      <tr>
                        <th className='totalGifts'>
                          <i className='iClass icon-ayuda tooltip-container'>
                            <span className='tooltip-box dir-left'>
                              {commonUtil.getLabel(
                                lables.eventAccountStatement,
                                'accountStatement.tooltip.message1'
                              )}
                            </span>
                          </i>
                          &nbsp;
                          {commonUtil.getLabel(
                            lables.eventAccountStatement,
                            'accountStatement.totalPurchase.message'
                          )}
                        </th>
                        <th className='colorBoldPink text-center'>
                          {itemInfo.totalPurchasedItemsCount}
                        </th>
                        <th>&nbsp;</th>
                        <th className='colorBoldBlack text-right'>
                          {commonUtil.getCurrency(
                            amountInfo.totalPurchasedAmount
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='styleCol1'>
                          <p>
                            {commonUtil.getLabel(
                              lables['Physical Gifts Details Page'],
                              'accountStatement.physical.label1'
                            )}
                            :
                          </p>
                          <Link rrLink={PhysicalJson}>
                            <span>
                              Ver detalle &nbsp;
                              <i
                                className='icon-flecha_gruesa_derecha'
                                aria-hidden='true'
                              />
                            </span>
                          </Link>
                        </td>
                        <td className='styleCol2 text-center'>
                          <p>{itemInfo.physicalItemInfo.totalPurchasedItems}</p>
                        </td>
                        <td className='styleCol3'>&nbsp;</td>
                        <td className='styleCol4 text-right'>
                          <p>
                            {commonUtil.getCurrency(
                              itemInfo.physicalItemInfo.totalPurchasedAmount
                            )}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className='styleCol1'>
                          <p>
                            {commonUtil.getLabel(
                              lables['Personal Gifts Details Page'],
                              'accountStatement.personal.label3'
                            )}
                            :
                          </p>
                          <Link rrLink={PersonalJson}>
                            <span>
                              Ver detalle &nbsp;
                              <i
                                className='icon-flecha_gruesa_derecha'
                                aria-hidden='true'
                              />
                            </span>
                          </Link>
                        </td>
                        <td className='styleCol2 text-center'>
                          <p>{itemInfo.personalItemInfo.totalPurchasedItems}</p>
                        </td>
                        <td className='styleCol3'>&nbsp;</td>
                        <td className='styleCol4 text-right'>
                          <p>
                            {commonUtil.getCurrency(
                              itemInfo.personalItemInfo.totalPurchasedAmount
                            )}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className='styleCol1'>
                          <p>
                            {commonUtil.getLabel(
                              lables['Electronic Gifts Details Page'],
                              'accountStatement.electronic.label2'
                            )}
                            :
                          </p>
                          <Link rrLink={ElectronicJson}>
                            <span>
                              Ver detalle &nbsp;
                              <i
                                className='icon-flecha_gruesa_derecha'
                                aria-hidden='true'
                              />
                            </span>
                          </Link>
                        </td>
                        <td className='styleCol2 text-center'>
                          <p>
                            {itemInfo.electronicItemInfo.totalPurchasedItems}
                          </p>
                        </td>
                        <td className='styleCol3'>
                          {itemInfo.electronicItemInfo.amountTransferred ? (
                            <div>
                              {' '}
                              <p>
                                Retiros anticipados -{' '}
                                {commonUtil.getCurrency(
                                  itemInfo.electronicItemInfo.amountTransferred
                                )}
                              </p>
                              <Link rrLink={AccountPartialTransferJson}>
                                <span>
                                  Ver detalle &nbsp;
                                  <i
                                    className='icon-flecha_gruesa_derecha'
                                    aria-hidden='true'
                                  />
                                </span>
                              </Link>
                            </div>
                          ) : null}
                        </td>
                        <td className='styleCol4 text-right'>
                          <p>
                            {commonUtil.getCurrency(
                              itemInfo.electronicItemInfo.totalPurchasedAmount
                            )}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-md-3 pr-0'>
                {isBonusContainerVisible ? (
                  <div className='gadget'>
                    <p>
                      <i
                        style={{ fontWeight: 700 }}
                        className='iClass icon-ayuda tooltip-container text-pink'
                      >
                        <span className='tooltip-box dir-left'>
                          {commonUtil.getLabel(
                            lables.eventAccountStatement,
                            'accountStatement.tooltip.message2'
                          )}
                        </span>
                      </i>
                      &nbsp;Aproximando de bono a monedero
                    </p>
                    <p className='price'>
                      {commonUtil.getCurrency(amountInfo.totalBonusAmount)}
                    </p>
                    {this.props.eventInfo.isEmployeeEvent ? (
                      <p className='ofert'>
                        {' '}
                        Por ser evento de casa {
                          accountData.bonusPercentage
                        }%{' '}
                        {commonUtil.getLabel(
                          lables.eventAccountStatement,
                          'accountStatement.bonus.message'
                        )}
                        , máximo a recibir{' '}
                        {commonUtil.getCurrency(amountInfo.totalBonusAmount)}
                      </p>
                    ) : (
                      <p className='ofert'>
                        {accountData.bonusPercentage}%{' '}
                        {commonUtil.getLabel(
                          lables.eventAccountStatement,
                          'accountStatement.bonus.message'
                        )}{' '}
                      </p>
                    )}
                    <p className='detail'>
                      <Link rrLink={BonusDetails}>
                        <span>
                          Ver detalle &nbsp;
                          <i
                            className='icon-flecha_gruesa_derecha'
                            aria-hidden='true'
                          />
                        </span>
                      </Link>
                    </p>
                  </div>
                ) : null}
                <div className='gadget'>
                  <div className='transitDiv'>
                    {+amountInfo.inTransitAmount !== 0 ? (
                      <div>
                        <div onClick={this.openTransitModal}>
                          <a
                            id='m-link'
                            className='titleTransit'
                            data-toggle='modal'
                            data-target='#transitProducts'
                          >
                            En tránsito
                          </a>{' '}
                          <a
                            id='m-link'
                            className='qntTransit'
                            data-toggle='modal'
                            data-target='#transitProducts'
                          >
                            {commonUtil.getCurrency(amountInfo.inTransitAmount)}
                          </a>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <ModalPopover
                    ref={(transitModal) => (this.transitModal = transitModal)}
                    headerTitleClass='text-left'
                    isModal='true'
                    header='Regalos en tránsito'
                    headerData={inTransitHeaderData}
                    modalId='transitProducts'
                  >
                    <Intransit
                      inTransitInfoData={this.props.intransitData}
                      lables={this.props.lables}
                    />
                  </ModalPopover>
                  <p>
                    <i
                      style={{ fontWeight: 700 }}
                      className='iClass icon-ayuda tooltip-container text-pink'
                    >
                      <span className='tooltip-box dir-left'>
                        {commonUtil.getLabel(
                          lables.eventAccountStatement,
                          'accountStatement.tooltip.message3'
                        )}
                      </span>
                    </i>
                    &nbsp; Disponible para retiro
                  </p>
                  <p className='price'>
                    {commonUtil.getCurrency(amountInfo.transferableAmount)}
                  </p>
                  <p className='transferent'>
                    {this.props.eventInfo.eventStatus === eventStatus.CLOSED ? (
                      ''
                    ) : (
                      <InputButton buttonAttr={partialTransferenceButton} />
                    )}
                  </p>
                  {accountData.employeeClosureMessage ? (
                    accountData.eventMessage.indexOf('No cuentas') === -1 ? (
                      <p style={{ paddingTop: '5%' }}>
                        Para hacer un retiro anticipado registra tu tarjeta en
                        tienda.
                      </p>
                    ) : (
                      <p>{accountData.employeeClosureMessage}</p>
                    )
                  ) : (
                    <React.Fragment>
                      {accountData.eventMessage &&
                      accountData.eventMessage.indexOf('Muchas') > -1 ? (
                        ''
                      ) : (
                        <div>
                          {commonUtil.getLabel(
                            this.props.lables.eventAccountStatement,
                            'accountStatement.closure.message'
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalPopover
          ref={(system) => (this.valeSystemModal = system)}
          isModal='true'
        >
          <button
            className='close closeClass'
            id='closeModal'
            type='button'
            data-dismiss='modal'
            aria-label='Close'
            style={webCloseBtn}
          >
            <span
              className='closeModal'
              aria-hidden='true'
              style={webCloseSpan}
            >
              ×
            </span>
          </button>
          <h4>
            <strong>
              {commonUtil.getLabel(
                lables['Event Account Landing page – Vales system down'],
                'accountStatement.valesystemdown.message1'
              )}
            </strong>
          </h4>
          <ValeSystemModal
            lables={this.props.lables}
            startTime={this._StartTime}
            endTime={this._EndTime}
          />
        </ModalPopover>
        <ModalPopover
          ref={(system) => (this.temporaryClosingModal = system)}
          isModal='true'
        >
          <button
            className='close'
            id='closeModal'
            type='button'
            data-dismiss='modal'
            aria-label='Close'
            style={webCloseBtn}
          >
            <span
              className='closeModal'
              aria-hidden='true'
              style={webCloseSpan}
            >
              ×
            </span>
          </button>
          <h4 style={webCloseModal}>Cierre de mesa</h4>
          <TemporaryClosingModal
            lables={this.props.lables}
            temporaryModal={this.onTemporaryClosingModalAcceptor}
            eventId={this.eventId}
          />
        </ModalPopover>
      </React.Fragment>
    );
  }
}
